import type { BrandPalette, EmpresaMarcaInput, PlantillaManifest } from './types';
import { paletaDesdeColores } from './palette';

export interface ContactosMarca {
  whatsapp: string;
  instagram: string;
  tienda: string;
  telefono: string;
}

export interface MarcaResuelta {
  palette: BrandPalette | null;
  logoUrl: string;
  businessName: string;
  sinLogo: boolean;
  sinColores: boolean;
  contactos: ContactosMarca;
}

export function usuarioInstagram(url?: string | null): string {
  if (!url) return '';
  const limpio = url.trim();
  if (limpio.startsWith('@')) return limpio;
  const m = limpio.match(/instagram\.com\/([^/?#]+)/i);
  if (!m) return '';
  const handle = (m[1] || '').replace(/\/$/, '');
  if (!handle || handle === 'p' || handle === 'reel' || handle === 'stories') return '';
  return `@${handle}`;
}

export function resolverMarca(empresa: EmpresaMarcaInput | null | undefined): MarcaResuelta {
  const branding = empresa?.configuracion?.branding;
  const colores = branding?.colores;
  const palette = paletaDesdeColores(colores);
  const logoUrl = branding?.logo || empresa?.logo_url || empresa?.logo || '';
  const businessName = branding?.nombreEmpresa || empresa?.nombre || '';
  const whatsapp = empresa?.configuracion?.contactoPublico?.whatsappBusiness || empresa?.telefono || '';
  return {
    palette,
    logoUrl,
    businessName,
    sinLogo: !logoUrl,
    sinColores: !palette,
    contactos: {
      whatsapp,
      instagram: usuarioInstagram(empresa?.instagram_url),
      tienda: empresa?.slug ? `clientelo.com.co/${empresa.slug}` : '',
      telefono: empresa?.telefono || '',
    },
  };
}

export const CTAS: { id: string; texto: string; contacto: keyof ContactosMarca }[] = [
  { id: 'whatsapp', texto: 'Pide por WhatsApp', contacto: 'whatsapp' },
  { id: 'instagram', texto: 'Escríbenos por Instagram', contacto: 'instagram' },
  { id: 'tienda', texto: 'Compra en nuestra tienda', contacto: 'tienda' },
  { id: 'telefono', texto: 'Llámanos', contacto: 'telefono' },
];

export function slotsIniciales(manifest: PlantillaManifest, marca: MarcaResuelta): Record<string, string> {
  const slots: Record<string, string> = {};
  for (const slot of manifest.slots) {
    if (slot.type === 'text' || slot.type === 'icon') slots[slot.name] = slot.ejemplo || '';
    else slots[slot.name] = '';
  }
  if (slots.business_name !== undefined && marca.businessName) slots.business_name = marca.businessName;
  if (slots.logo !== undefined && marca.logoUrl) slots.logo = marca.logoUrl;
  return slots;
}

export function aplicarMarcaEnSlots(slots: Record<string, string>, marca: MarcaResuelta): Record<string, string> {
  const next = { ...slots };
  if (next.business_name !== undefined && marca.businessName) next.business_name = marca.businessName;
  if (next.logo !== undefined) next.logo = marca.logoUrl || '';
  return next;
}

export function formatoCop(valor: number): string {
  return `$${Math.round(valor).toLocaleString('es-CO')}`;
}
